export default "__VITE_ASSET__NQRrlUoe__"